import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _8cfb4392 = () => interopDefault(import('../pages/activity_logs/index.vue' /* webpackChunkName: "pages/activity_logs/index" */))
const _02d7c695 = () => interopDefault(import('../pages/alerts/index.vue' /* webpackChunkName: "pages/alerts/index" */))
const _303ac89e = () => interopDefault(import('../pages/audit_identifiers/index.vue' /* webpackChunkName: "pages/audit_identifiers/index" */))
const _037b4fa6 = () => interopDefault(import('../pages/audit_types/index.vue' /* webpackChunkName: "pages/audit_types/index" */))
const _1125d2be = () => interopDefault(import('../pages/change_locale/index.vue' /* webpackChunkName: "pages/change_locale/index" */))
const _e1d60140 = () => interopDefault(import('../pages/custom_embeds/index.vue' /* webpackChunkName: "pages/custom_embeds/index" */))
const _b2827a82 = () => interopDefault(import('../pages/custom_tags/index.vue' /* webpackChunkName: "pages/custom_tags/index" */))
const _059851b6 = () => interopDefault(import('../pages/customer_libraries/index.vue' /* webpackChunkName: "pages/customer_libraries/index" */))
const _f5e06d0e = () => interopDefault(import('../pages/departments/index.vue' /* webpackChunkName: "pages/departments/index" */))
const _44d33e08 = () => interopDefault(import('../pages/design/index.vue' /* webpackChunkName: "pages/design/index" */))
const _20a36b16 = () => interopDefault(import('../pages/devices/index.vue' /* webpackChunkName: "pages/devices/index" */))
const _40a1eb9d = () => interopDefault(import('../pages/home/index.vue' /* webpackChunkName: "pages/home/index" */))
const _5785ab58 = () => interopDefault(import('../pages/jobs/index.vue' /* webpackChunkName: "pages/jobs/index" */))
const _f3bf761a = () => interopDefault(import('../pages/languages/index.vue' /* webpackChunkName: "pages/languages/index" */))
const _7fab0e19 = () => interopDefault(import('../pages/left_early_reasons/index.vue' /* webpackChunkName: "pages/left_early_reasons/index" */))
const _35e23a44 = () => interopDefault(import('../pages/lessee_selection/index.vue' /* webpackChunkName: "pages/lessee_selection/index" */))
const _b58675ca = () => interopDefault(import('../pages/licence_logs/index.vue' /* webpackChunkName: "pages/licence_logs/index" */))
const _33114d7e = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _146163e6 = () => interopDefault(import('../pages/ndas/index.vue' /* webpackChunkName: "pages/ndas/index" */))
const _45385e6a = () => interopDefault(import('../pages/question_tags/index.vue' /* webpackChunkName: "pages/question_tags/index" */))
const _24eac61f = () => interopDefault(import('../pages/ranks/index.vue' /* webpackChunkName: "pages/ranks/index" */))
const _2ede1a8b = () => interopDefault(import('../pages/recipient_libraries/index.vue' /* webpackChunkName: "pages/recipient_libraries/index" */))
const _4be060d3 = () => interopDefault(import('../pages/redis/index.vue' /* webpackChunkName: "pages/redis/index" */))
const _ecb0c43a = () => interopDefault(import('../pages/report_statuses/index.vue' /* webpackChunkName: "pages/report_statuses/index" */))
const _2bb8c700 = () => interopDefault(import('../pages/scheduled_questionnaires/index.vue' /* webpackChunkName: "pages/scheduled_questionnaires/index" */))
const _4a294dd9 = () => interopDefault(import('../pages/severities/index.vue' /* webpackChunkName: "pages/severities/index" */))
const _5e880bd2 = () => interopDefault(import('../pages/shift_descriptions/index.vue' /* webpackChunkName: "pages/shift_descriptions/index" */))
const _12c677b8 = () => interopDefault(import('../pages/sites/index.vue' /* webpackChunkName: "pages/sites/index" */))
const _dfca2f80 = () => interopDefault(import('../pages/states/index.vue' /* webpackChunkName: "pages/states/index" */))
const _147b9e03 = () => interopDefault(import('../pages/superuser_only/index.vue' /* webpackChunkName: "pages/superuser_only/index" */))
const _83301de8 = () => interopDefault(import('../pages/suspect_code_models/index.vue' /* webpackChunkName: "pages/suspect_code_models/index" */))
const _694985bc = () => interopDefault(import('../pages/tablet_roles/index.vue' /* webpackChunkName: "pages/tablet_roles/index" */))
const _7b962b52 = () => interopDefault(import('../pages/tags/index.vue' /* webpackChunkName: "pages/tags/index" */))
const _2545e672 = () => interopDefault(import('../pages/unauthorized/index.vue' /* webpackChunkName: "pages/unauthorized/index" */))
const _315505c0 = () => interopDefault(import('../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _cc61cfd4 = () => interopDefault(import('../pages/work_areas/index.vue' /* webpackChunkName: "pages/work_areas/index" */))
const _1fbd3e9f = () => interopDefault(import('../pages/zones/index.vue' /* webpackChunkName: "pages/zones/index" */))
const _0c719f66 = () => interopDefault(import('../pages/alerts/new/index.vue' /* webpackChunkName: "pages/alerts/new/index" */))
const _16b901e2 = () => interopDefault(import('../pages/audit/questionnaire_groups/index.vue' /* webpackChunkName: "pages/audit/questionnaire_groups/index" */))
const _560a275e = () => interopDefault(import('../pages/audit/scheduled_questionnaire_notifications/index.vue' /* webpackChunkName: "pages/audit/scheduled_questionnaire_notifications/index" */))
const _08a2146c = () => interopDefault(import('../pages/auth/signed-in.vue' /* webpackChunkName: "pages/auth/signed-in" */))
const _7d651504 = () => interopDefault(import('../pages/customers/new/index.vue' /* webpackChunkName: "pages/customers/new/index" */))
const _e1a7990c = () => interopDefault(import('../pages/dashboard/devices/index.vue' /* webpackChunkName: "pages/dashboard/devices/index" */))
const _c247a170 = () => interopDefault(import('../pages/dashboard/panels/index.vue' /* webpackChunkName: "pages/dashboard/panels/index" */))
const _038ee264 = () => interopDefault(import('../pages/defects/view_by_suspect_code/index.vue' /* webpackChunkName: "pages/defects/view_by_suspect_code/index" */))
const _a5ae6532 = () => interopDefault(import('../pages/departments/roles/index.vue' /* webpackChunkName: "pages/departments/roles/index" */))
const _de92c8bc = () => interopDefault(import('../pages/design/TemplateForms/index.vue' /* webpackChunkName: "pages/design/TemplateForms/index" */))
const _343dc43e = () => interopDefault(import('../pages/design/TemplateForms/index/Basic.vue' /* webpackChunkName: "pages/design/TemplateForms/index/Basic" */))
const _7233d1fe = () => interopDefault(import('../pages/design/TemplateForms/index/Fieldsets.vue' /* webpackChunkName: "pages/design/TemplateForms/index/Fieldsets" */))
const _72251a01 = () => interopDefault(import('../pages/design/TemplateForms/index/SubSections.vue' /* webpackChunkName: "pages/design/TemplateForms/index/SubSections" */))
const _702576ee = () => interopDefault(import('../pages/design/TemplateForms/index/TabsInSections.vue' /* webpackChunkName: "pages/design/TemplateForms/index/TabsInSections" */))
const _c0484d82 = () => interopDefault(import('../pages/devices/show_licence/index.vue' /* webpackChunkName: "pages/devices/show_licence/index" */))
const _4b7d78d7 = () => interopDefault(import('../pages/devices/unassigned/index.vue' /* webpackChunkName: "pages/devices/unassigned/index" */))
const _c5782d66 = () => interopDefault(import('../pages/downtime/reasons/index.vue' /* webpackChunkName: "pages/downtime/reasons/index" */))
const _bf63c4e0 = () => interopDefault(import('../pages/events/users/index.vue' /* webpackChunkName: "pages/events/users/index" */))
const _9a74868a = () => interopDefault(import('../pages/failures/view_with_answer/index.vue' /* webpackChunkName: "pages/failures/view_with_answer/index" */))
const _4f12aa92 = () => interopDefault(import('../pages/jobs/index_for_customer/index.vue' /* webpackChunkName: "pages/jobs/index_for_customer/index" */))
const _20f10ba5 = () => interopDefault(import('../pages/jobs/new/index.vue' /* webpackChunkName: "pages/jobs/new/index" */))
const _51c54a4c = () => interopDefault(import('../pages/login/auth/index.vue' /* webpackChunkName: "pages/login/auth/index" */))
const _4e78512e = () => interopDefault(import('../pages/login/forgot_password/index.vue' /* webpackChunkName: "pages/login/forgot_password/index" */))
const _1aadc457 = () => interopDefault(import('../pages/login/mobile_auth/index.vue' /* webpackChunkName: "pages/login/mobile_auth/index" */))
const _6ef98e93 = () => interopDefault(import('../pages/reports/atlas/index.vue' /* webpackChunkName: "pages/reports/atlas/index" */))
const _a086092e = () => interopDefault(import('../pages/reports/backsheets/index.vue' /* webpackChunkName: "pages/reports/backsheets/index" */))
const _6bdcde7a = () => interopDefault(import('../pages/reports/corrective_actions/index.vue' /* webpackChunkName: "pages/reports/corrective_actions/index" */))
const _3f75e1ae = () => interopDefault(import('../pages/reports/heatmap_search/index.vue' /* webpackChunkName: "pages/reports/heatmap_search/index" */))
const _06ae5715 = () => interopDefault(import('../pages/reports/heatmaps/index.vue' /* webpackChunkName: "pages/reports/heatmaps/index" */))
const _d1bb7a3a = () => interopDefault(import('../pages/reports/ichart/index.vue' /* webpackChunkName: "pages/reports/ichart/index" */))
const _21ff76a2 = () => interopDefault(import('../pages/reports/questionnaire_results/index.vue' /* webpackChunkName: "pages/reports/questionnaire_results/index" */))
const _0a6cdf6a = () => interopDefault(import('../pages/reports/questionnaire_stats/index.vue' /* webpackChunkName: "pages/reports/questionnaire_stats/index" */))
const _8aae49e6 = () => interopDefault(import('../pages/reports/reject_stats/index.vue' /* webpackChunkName: "pages/reports/reject_stats/index" */))
const _5578aed8 = () => interopDefault(import('../pages/reports/reject_summary/index.vue' /* webpackChunkName: "pages/reports/reject_summary/index" */))
const _cd7da13e = () => interopDefault(import('../pages/reports/shift_by_date/index.vue' /* webpackChunkName: "pages/reports/shift_by_date/index" */))
const _2d0982ff = () => interopDefault(import('../pages/reports/shifts/index.vue' /* webpackChunkName: "pages/reports/shifts/index" */))
const _12f505a7 = () => interopDefault(import('../pages/reports/stats/index.vue' /* webpackChunkName: "pages/reports/stats/index" */))
const _08472f5f = () => interopDefault(import('../pages/reports/suspect_stats/index.vue' /* webpackChunkName: "pages/reports/suspect_stats/index" */))
const _601176c2 = () => interopDefault(import('../pages/reports/training_results/index.vue' /* webpackChunkName: "pages/reports/training_results/index" */))
const _11bf200f = () => interopDefault(import('../pages/reports/training_results/index/_exam_result_id/index.vue' /* webpackChunkName: "pages/reports/training_results/index/_exam_result_id/index" */))
const _6f62c817 = () => interopDefault(import('../pages/reports/training_results/index/_user_id/by_user/index.vue' /* webpackChunkName: "pages/reports/training_results/index/_user_id/by_user/index" */))
const _347a8920 = () => interopDefault(import('../pages/reports/work_items/index.vue' /* webpackChunkName: "pages/reports/work_items/index" */))
const _532c9346 = () => interopDefault(import('../pages/suspect_code_models/new/index.vue' /* webpackChunkName: "pages/suspect_code_models/new/index" */))
const _7ade4dbd = () => interopDefault(import('../pages/training/exams/index.vue' /* webpackChunkName: "pages/training/exams/index" */))
const _9f7aace0 = () => interopDefault(import('../pages/users/choose_deactivation/index.vue' /* webpackChunkName: "pages/users/choose_deactivation/index" */))
const _76cb1871 = () => interopDefault(import('../pages/users/new/index.vue' /* webpackChunkName: "pages/users/new/index" */))
const _4c6136c4 = () => interopDefault(import('../pages/workflows/simples/index.vue' /* webpackChunkName: "pages/workflows/simples/index" */))
const _6b2ffb20 = () => interopDefault(import('../pages/zones/new/index.vue' /* webpackChunkName: "pages/zones/new/index" */))
const _6af718a2 = () => interopDefault(import('../pages/audit/scheduled_questionnaire_notifications/new/index.vue' /* webpackChunkName: "pages/audit/scheduled_questionnaire_notifications/new/index" */))
const _6c4712ce = () => interopDefault(import('../pages/dashboard/panels/new/index.vue' /* webpackChunkName: "pages/dashboard/panels/new/index" */))
const _f7973212 = () => interopDefault(import('../pages/design/1-Quarks/Colours.vue' /* webpackChunkName: "pages/design/1-Quarks/Colours" */))
const _cd577f58 = () => interopDefault(import('../pages/design/1-Quarks/Fonts.vue' /* webpackChunkName: "pages/design/1-Quarks/Fonts" */))
const _bb86cb2c = () => interopDefault(import('../pages/design/1-Quarks/Icons.vue' /* webpackChunkName: "pages/design/1-Quarks/Icons" */))
const _39666c40 = () => interopDefault(import('../pages/design/2-Atoms/Button.vue' /* webpackChunkName: "pages/design/2-Atoms/Button" */))
const _31d5bf1e = () => interopDefault(import('../pages/design/2-Atoms/Checkbox.vue' /* webpackChunkName: "pages/design/2-Atoms/Checkbox" */))
const _00d9d1b9 = () => interopDefault(import('../pages/design/2-Atoms/EdnFieldset.vue' /* webpackChunkName: "pages/design/2-Atoms/EdnFieldset" */))
const _61ed34af = () => interopDefault(import('../pages/design/2-Atoms/EdnMultiselects.vue' /* webpackChunkName: "pages/design/2-Atoms/EdnMultiselects" */))
const _9b46f308 = () => interopDefault(import('../pages/design/2-Atoms/InfoBannerSwitch.vue' /* webpackChunkName: "pages/design/2-Atoms/InfoBannerSwitch" */))
const _512aa36e = () => interopDefault(import('../pages/design/2-Atoms/JobStatusIndicator.vue' /* webpackChunkName: "pages/design/2-Atoms/JobStatusIndicator" */))
const _2e94ab7d = () => interopDefault(import('../pages/design/2-Atoms/ListWithDelete.vue' /* webpackChunkName: "pages/design/2-Atoms/ListWithDelete" */))
const _40c30b7e = () => interopDefault(import('../pages/design/2-Atoms/Loader.vue' /* webpackChunkName: "pages/design/2-Atoms/Loader" */))
const _cad22970 = () => interopDefault(import('../pages/design/2-Atoms/Pagination.vue' /* webpackChunkName: "pages/design/2-Atoms/Pagination" */))
const _5eb33801 = () => interopDefault(import('../pages/design/2-Atoms/SearchableCheckboxes.vue' /* webpackChunkName: "pages/design/2-Atoms/SearchableCheckboxes" */))
const _fb93f1fa = () => interopDefault(import('../pages/design/2-Atoms/SearchHeader.vue' /* webpackChunkName: "pages/design/2-Atoms/SearchHeader" */))
const _329e4443 = () => interopDefault(import('../pages/design/2-Atoms/SliderToggle.vue' /* webpackChunkName: "pages/design/2-Atoms/SliderToggle" */))
const _563f0390 = () => interopDefault(import('../pages/design/2-Atoms/Table.vue' /* webpackChunkName: "pages/design/2-Atoms/Table" */))
const _5360e6f0 = () => interopDefault(import('../pages/design/2-Atoms/TextArea.vue' /* webpackChunkName: "pages/design/2-Atoms/TextArea" */))
const _61fff9df = () => interopDefault(import('../pages/design/2-Atoms/TextInput.vue' /* webpackChunkName: "pages/design/2-Atoms/TextInput" */))
const _c9c305fc = () => interopDefault(import('../pages/design/2-Atoms/Toggle.vue' /* webpackChunkName: "pages/design/2-Atoms/Toggle" */))
const _42266b8a = () => interopDefault(import('../pages/design/2-Atoms/ViewBy.vue' /* webpackChunkName: "pages/design/2-Atoms/ViewBy" */))
const _287395bc = () => interopDefault(import('../pages/design/3-Molecules/AutoLogOutModal.vue' /* webpackChunkName: "pages/design/3-Molecules/AutoLogOutModal" */))
const _1e20db29 = () => interopDefault(import('../pages/design/3-Molecules/BarcodeVerification.vue' /* webpackChunkName: "pages/design/3-Molecules/BarcodeVerification" */))
const _fbc2f614 = () => interopDefault(import('../pages/design/3-Molecules/Comments.vue' /* webpackChunkName: "pages/design/3-Molecules/Comments" */))
const _5c7f79cb = () => interopDefault(import('../pages/design/3-Molecules/EditExam.vue' /* webpackChunkName: "pages/design/3-Molecules/EditExam" */))
const _5234799e = () => interopDefault(import('../pages/design/3-Molecules/ExamResult.vue' /* webpackChunkName: "pages/design/3-Molecules/ExamResult" */))
const _f6f6ca52 = () => interopDefault(import('../pages/design/3-Molecules/ImageUploader.vue' /* webpackChunkName: "pages/design/3-Molecules/ImageUploader" */))
const _d7a0e58a = () => interopDefault(import('../pages/design/3-Molecules/JobQuestionnaires.vue' /* webpackChunkName: "pages/design/3-Molecules/JobQuestionnaires" */))
const _8fb090c0 = () => interopDefault(import('../pages/design/3-Molecules/List.vue' /* webpackChunkName: "pages/design/3-Molecules/List" */))
const _21368be8 = () => interopDefault(import('../pages/design/3-Molecules/Modals.vue' /* webpackChunkName: "pages/design/3-Molecules/Modals" */))
const _78116394 = () => interopDefault(import('../pages/design/3-Molecules/MyDashboard.vue' /* webpackChunkName: "pages/design/3-Molecules/MyDashboard" */))
const _0f0d13ab = () => interopDefault(import('../pages/design/3-Molecules/PartsPerHourChart.vue' /* webpackChunkName: "pages/design/3-Molecules/PartsPerHourChart" */))
const _524ea48e = () => interopDefault(import('../pages/design/3-Molecules/PayableTimeSummary.vue' /* webpackChunkName: "pages/design/3-Molecules/PayableTimeSummary" */))
const _7a8cca0c = () => interopDefault(import('../pages/design/3-Molecules/RadarChart.vue' /* webpackChunkName: "pages/design/3-Molecules/RadarChart" */))
const _63094665 = () => interopDefault(import('../pages/design/3-Molecules/Selects.vue' /* webpackChunkName: "pages/design/3-Molecules/Selects" */))
const _2e8d2852 = () => interopDefault(import('../pages/design/3-Molecules/StatsGraphs.vue' /* webpackChunkName: "pages/design/3-Molecules/StatsGraphs" */))
const _fc297600 = () => interopDefault(import('../pages/design/3-Molecules/StatsTableTotals.vue' /* webpackChunkName: "pages/design/3-Molecules/StatsTableTotals" */))
const _32eeca80 = () => interopDefault(import('../pages/design/3-Molecules/Tabs.vue' /* webpackChunkName: "pages/design/3-Molecules/Tabs" */))
const _d060331a = () => interopDefault(import('../pages/design/DontCopyThis/StickyHeaderTable.vue' /* webpackChunkName: "pages/design/DontCopyThis/StickyHeaderTable" */))
const _747ff4f4 = () => interopDefault(import('../pages/design/Examples/Form.vue' /* webpackChunkName: "pages/design/Examples/Form" */))
const _1399270e = () => interopDefault(import('../pages/design/TemplateForms/Validation.vue' /* webpackChunkName: "pages/design/TemplateForms/Validation" */))
const _4f24779b = () => interopDefault(import('../pages/hrs/reports/payable_hours_summary/index.vue' /* webpackChunkName: "pages/hrs/reports/payable_hours_summary/index" */))
const _fc57817c = () => interopDefault(import('../pages/hrs/reports/roll_call/index.vue' /* webpackChunkName: "pages/hrs/reports/roll_call/index" */))
const _3fb38c70 = () => interopDefault(import('../pages/hrs/reports/time_sheets/index.vue' /* webpackChunkName: "pages/hrs/reports/time_sheets/index" */))
const _6e0dd7c2 = () => interopDefault(import('../pages/hrs/reports/time_sheets_by_job/index.vue' /* webpackChunkName: "pages/hrs/reports/time_sheets_by_job/index" */))
const _5dd6d194 = () => interopDefault(import('../pages/importers/bundles/users/index.vue' /* webpackChunkName: "pages/importers/bundles/users/index" */))
const _08891fb0 = () => interopDefault(import('../pages/library/assets/videos/index.vue' /* webpackChunkName: "pages/library/assets/videos/index" */))
const _40528263 = () => interopDefault(import('../pages/translations/roles/edit_all/index.vue' /* webpackChunkName: "pages/translations/roles/edit_all/index" */))
const _172e91fd = () => interopDefault(import('../pages/audit/corrective_action/plans/list/index.vue' /* webpackChunkName: "pages/audit/corrective_action/plans/list/index" */))
const _398b7ff1 = () => interopDefault(import('../pages/design/2-Atoms/Datetime/Datetime.vue' /* webpackChunkName: "pages/design/2-Atoms/Datetime/Datetime" */))
const _d6c80264 = () => interopDefault(import('../pages/design/2-Atoms/Datetime/StartAndEndDate.vue' /* webpackChunkName: "pages/design/2-Atoms/Datetime/StartAndEndDate" */))
const _a9a92cba = () => interopDefault(import('../pages/design/2-Atoms/Datetime/StartDateComponent.vue' /* webpackChunkName: "pages/design/2-Atoms/Datetime/StartDateComponent" */))
const _4e0d9968 = () => interopDefault(import('../pages/design/3-Molecules/ActionCell/Default.vue' /* webpackChunkName: "pages/design/3-Molecules/ActionCell/Default" */))
const _73ffcf23 = () => interopDefault(import('../pages/design/3-Molecules/ActionCell/Editing.vue' /* webpackChunkName: "pages/design/3-Molecules/ActionCell/Editing" */))
const _557bf9a9 = () => interopDefault(import('../pages/design/3-Molecules/Audit/QuestionnaireResults.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/QuestionnaireResults" */))
const _0f246ae2 = () => interopDefault(import('../pages/design/3-Molecules/Gauges/AnswersBreakdown.vue' /* webpackChunkName: "pages/design/3-Molecules/Gauges/AnswersBreakdown" */))
const _7f32a315 = () => interopDefault(import('../pages/design/3-Molecules/Gauges/AuditsPerformed.vue' /* webpackChunkName: "pages/design/3-Molecules/Gauges/AuditsPerformed" */))
const _71919e3e = () => interopDefault(import('../pages/design/3-Molecules/Gauges/Compliance.vue' /* webpackChunkName: "pages/design/3-Molecules/Gauges/Compliance" */))
const _7464e573 = () => interopDefault(import('../pages/design/3-Molecules/Gauges/CorrectiveActionResolution.vue' /* webpackChunkName: "pages/design/3-Molecules/Gauges/CorrectiveActionResolution" */))
const _be59ddc0 = () => interopDefault(import('../pages/design/3-Molecules/Gauges/EmbedLink.vue' /* webpackChunkName: "pages/design/3-Molecules/Gauges/EmbedLink" */))
const _98cb1ad6 = () => interopDefault(import('../pages/design/3-Molecules/Gauges/ScheduledCompliance.vue' /* webpackChunkName: "pages/design/3-Molecules/Gauges/ScheduledCompliance" */))
const _dfa823f2 = () => interopDefault(import('../pages/design/3-Molecules/Timesheets/ActivityDetails.vue' /* webpackChunkName: "pages/design/3-Molecules/Timesheets/ActivityDetails" */))
const _577286a3 = () => interopDefault(import('../pages/design/3-Molecules/Timesheets/NewActivity.vue' /* webpackChunkName: "pages/design/3-Molecules/Timesheets/NewActivity" */))
const _0d60142e = () => interopDefault(import('../pages/design/3-Molecules/Timesheets/NewShiftDescription.vue' /* webpackChunkName: "pages/design/3-Molecules/Timesheets/NewShiftDescription" */))
const _172ce1ae = () => interopDefault(import('../pages/design/3-Molecules/Timesheets/TimeByJobSummary.vue' /* webpackChunkName: "pages/design/3-Molecules/Timesheets/TimeByJobSummary" */))
const _486c09e5 = () => interopDefault(import('../pages/design/3-Molecules/Timesheets/TimesheetsSearch.vue' /* webpackChunkName: "pages/design/3-Molecules/Timesheets/TimesheetsSearch" */))
const _d000ad3e = () => interopDefault(import('../pages/design/3-Molecules/Timesheets/ViewTimesheet.vue' /* webpackChunkName: "pages/design/3-Molecules/Timesheets/ViewTimesheet" */))
const _02864204 = () => interopDefault(import('../pages/design/3-Molecules/Training/ExamResults.vue' /* webpackChunkName: "pages/design/3-Molecules/Training/ExamResults" */))
const _160338a0 = () => interopDefault(import('../pages/design/3-Molecules/Training/ExamResultsSearchForm.vue' /* webpackChunkName: "pages/design/3-Molecules/Training/ExamResultsSearchForm" */))
const _53afbc26 = () => interopDefault(import('../pages/design/TemplateForms/Search/FiltersInHeader.vue' /* webpackChunkName: "pages/design/TemplateForms/Search/FiltersInHeader" */))
const _a88c0a10 = () => interopDefault(import('../pages/design/TemplateForms/Search/FiltersInHeaderWithPresets.vue' /* webpackChunkName: "pages/design/TemplateForms/Search/FiltersInHeaderWithPresets" */))
const _351f3eba = () => interopDefault(import('../pages/design/TemplateForms/Search/InASection/index.vue' /* webpackChunkName: "pages/design/TemplateForms/Search/InASection/index" */))
const _e807e410 = () => interopDefault(import('../pages/design/TemplateForms/Search/InASection/index/Tab1.vue' /* webpackChunkName: "pages/design/TemplateForms/Search/InASection/index/Tab1" */))
const _e7ebb50e = () => interopDefault(import('../pages/design/TemplateForms/Search/InASection/index/Tab2.vue' /* webpackChunkName: "pages/design/TemplateForms/Search/InASection/index/Tab2" */))
const _40acbdee = () => interopDefault(import('../pages/importers/bundles/audit/questionnaire_groups/index.vue' /* webpackChunkName: "pages/importers/bundles/audit/questionnaire_groups/index" */))
const _64f10012 = () => interopDefault(import('../pages/template/audit/corrective_action/champions/index.vue' /* webpackChunkName: "pages/template/audit/corrective_action/champions/index" */))
const _a1473938 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/QuestionnaireEdit.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/QuestionnaireEdit" */))
const _54916bb0 = () => interopDefault(import('../pages/design/3-Molecules/Gauges/AuditScore/BarChart.vue' /* webpackChunkName: "pages/design/3-Molecules/Gauges/AuditScore/BarChart" */))
const _3d9c66dd = () => interopDefault(import('../pages/design/3-Molecules/Gauges/AuditScore/RadarChart.vue' /* webpackChunkName: "pages/design/3-Molecules/Gauges/AuditScore/RadarChart" */))
const _36bbcefa = () => interopDefault(import('../pages/design/3-Molecules/Gauges/CorrectiveAction/BarChart.vue' /* webpackChunkName: "pages/design/3-Molecules/Gauges/CorrectiveAction/BarChart" */))
const _69b3f816 = () => interopDefault(import('../pages/design/3-Molecules/Gauges/CorrectiveAction/List.vue' /* webpackChunkName: "pages/design/3-Molecules/Gauges/CorrectiveAction/List" */))
const _e07809ac = () => interopDefault(import('../pages/design/3-Molecules/Gauges/CorrectiveAction/PieChart.vue' /* webpackChunkName: "pages/design/3-Molecules/Gauges/CorrectiveAction/PieChart" */))
const _eeb96adc = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/Answers.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/Answers" */))
const _8c9bc684 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/CameraCapture.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/CameraCapture" */))
const _0b259098 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/ControlChart.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/ControlChart" */))
const _2c3ddfee = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/Heatmap.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/Heatmap" */))
const _7031035c = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/InspectorSignatureAnswer.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/InspectorSignatureAnswer" */))
const _14370312 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/Multiselect.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/Multiselect" */))
const _44fa587b = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/OtherSignature.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/OtherSignature" */))
const _1bc9b8e1 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/PartVerification.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/PartVerification" */))
const _0dabdefc = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/PassFail.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/PassFail" */))
const _06124a48 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/PokeYoke.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/PokeYoke" */))
const _d559f844 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/ScorePassFail.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/ScorePassFail" */))
const _8b5bc4a0 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/Severity.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/Severity" */))
const _5b6308ea = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/Tolerance.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/Tolerance" */))
const _d37ffa64 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/Value.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/Value" */))
const _6c00c3e7 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Answers/ValueCompare.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Answers/ValueCompare" */))
const _5147bbd6 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/CameraCapture.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/CameraCapture" */))
const _289b559c = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/ControlChart.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/ControlChart" */))
const _64fc3dbe = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/Heatmap.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/Heatmap" */))
const _6556d65c = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/InspectorSignature.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/InspectorSignature" */))
const _ab4cefac = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/Multiselect.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/Multiselect" */))
const _bfcec73a = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/OtherSignature.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/OtherSignature" */))
const _2866a2c9 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/PartVerification.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/PartVerification" */))
const _ecb93b2c = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/PassFail.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/PassFail" */))
const _2ce8a2f6 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/ScorePassFail.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/ScorePassFail" */))
const _4acb6f98 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/Severity.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/Severity" */))
const _4bd817fc = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/Tolerance.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/Tolerance" */))
const _059239e6 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/Value.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/Value" */))
const _cba23c62 = () => interopDefault(import('../pages/design/3-Molecules/Audit/Questionnaires/Questions/ValueCompare.vue' /* webpackChunkName: "pages/design/3-Molecules/Audit/Questionnaires/Questions/ValueCompare" */))
const _6960d3b2 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3421c762 = () => interopDefault(import('../pages/template/audit/corrective_action/champions/_id/index.vue' /* webpackChunkName: "pages/template/audit/corrective_action/champions/_id/index" */))
const _8835e2d4 = () => interopDefault(import('../pages/importers/bundles/audit/questionnaire_groups/_id/edit/index.vue' /* webpackChunkName: "pages/importers/bundles/audit/questionnaire_groups/_id/edit/index" */))
const _766f7f98 = () => interopDefault(import('../pages/dashboard/devices/questionnaire_result/_device_identifier/index.vue' /* webpackChunkName: "pages/dashboard/devices/questionnaire_result/_device_identifier/index" */))
const _50d4622f = () => interopDefault(import('../pages/audit/answers/failures/_id/edit/index.vue' /* webpackChunkName: "pages/audit/answers/failures/_id/edit/index" */))
const _06145ecc = () => interopDefault(import('../pages/dashboard/devices/jobs/_job/embed/index.vue' /* webpackChunkName: "pages/dashboard/devices/jobs/_job/embed/index" */))
const _5e2060d8 = () => interopDefault(import('../pages/dashboard/devices/jobs/_job/ichart/index.vue' /* webpackChunkName: "pages/dashboard/devices/jobs/_job/ichart/index" */))
const _53c3fd88 = () => interopDefault(import('../pages/dashboard/devices/jobs/_job/instruction_search/index.vue' /* webpackChunkName: "pages/dashboard/devices/jobs/_job/instruction_search/index" */))
const _25fd100d = () => interopDefault(import('../pages/dashboard/devices/jobs/_job/questionnaire_results/index.vue' /* webpackChunkName: "pages/dashboard/devices/jobs/_job/questionnaire_results/index" */))
const _68fa4933 = () => interopDefault(import('../pages/dashboard/devices/jobs/_job/questionnaires/index.vue' /* webpackChunkName: "pages/dashboard/devices/jobs/_job/questionnaires/index" */))
const _123112eb = () => interopDefault(import('../pages/dashboard/devices/jobs/_job/request_assistance/index.vue' /* webpackChunkName: "pages/dashboard/devices/jobs/_job/request_assistance/index" */))
const _5b70d512 = () => interopDefault(import('../pages/dashboard/devices/jobs/_job/stats/index.vue' /* webpackChunkName: "pages/dashboard/devices/jobs/_job/stats/index" */))
const _38a4ec84 = () => interopDefault(import('../pages/dashboard/devices/jobs/_job/verification_stats/index.vue' /* webpackChunkName: "pages/dashboard/devices/jobs/_job/verification_stats/index" */))
const _7db3fb69 = () => interopDefault(import('../pages/dashboard/devices/jobs/_job/verification_work_items/index.vue' /* webpackChunkName: "pages/dashboard/devices/jobs/_job/verification_work_items/index" */))
const _40897f7c = () => interopDefault(import('../pages/dashboard/devices/questionnaire_results/_questionnaire_result_id/questionnaire_result/index.vue' /* webpackChunkName: "pages/dashboard/devices/questionnaire_results/_questionnaire_result_id/questionnaire_result/index" */))
const _43fe7376 = () => interopDefault(import('../pages/dashboard/devices/questions/_question_id/failures_for_question/index.vue' /* webpackChunkName: "pages/dashboard/devices/questions/_question_id/failures_for_question/index" */))
const _ae0094a0 = () => interopDefault(import('../pages/importers/bundles/users/_id/edit/index.vue' /* webpackChunkName: "pages/importers/bundles/users/_id/edit/index" */))
const _21d8aeb0 = () => interopDefault(import('../pages/activity_logs/for_device/_device_id/index.vue' /* webpackChunkName: "pages/activity_logs/for_device/_device_id/index" */))
const _b992b474 = () => interopDefault(import('../pages/activity_logs/for_user/_user_id/index.vue' /* webpackChunkName: "pages/activity_logs/for_user/_user_id/index" */))
const _b8cb4866 = () => interopDefault(import('../pages/audit/questionnaire_groups/_id/index.vue' /* webpackChunkName: "pages/audit/questionnaire_groups/_id/index" */))
const _3c07339a = () => interopDefault(import('../pages/dashboard/panels/_id/index.vue' /* webpackChunkName: "pages/dashboard/panels/_id/index" */))
const _6176cc5b = () => interopDefault(import('../pages/hrs/time_sheets/_time_sheet_id/index.vue' /* webpackChunkName: "pages/hrs/time_sheets/_time_sheet_id/index" */))
const _4a321816 = () => interopDefault(import('../pages/saved_report/ichart/_key/index.vue' /* webpackChunkName: "pages/saved_report/ichart/_key/index" */))
const _58088bbe = () => interopDefault(import('../pages/saved_report/view_all_shifts/_key/index.vue' /* webpackChunkName: "pages/saved_report/view_all_shifts/_key/index" */))
const _afaf53bc = () => interopDefault(import('../pages/saved_report/view_defect_by_description/_key/index.vue' /* webpackChunkName: "pages/saved_report/view_defect_by_description/_key/index" */))
const _cfcc57ba = () => interopDefault(import('../pages/scheduled_questionnaires/new/_zone_id/index.vue' /* webpackChunkName: "pages/scheduled_questionnaires/new/_zone_id/index" */))
const _0fd913b8 = () => interopDefault(import('../pages/training/exams/_exam_id/index.vue' /* webpackChunkName: "pages/training/exams/_exam_id/index" */))
const _a82e72f0 = () => interopDefault(import('../pages/audit/questionnaire_groups/_id/questionnaires/index.vue' /* webpackChunkName: "pages/audit/questionnaire_groups/_id/questionnaires/index" */))
const _57bb04a2 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index" */))
const _f433ecb6 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/index" */))
const _a94dc0d8 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/expansions/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/expansions/index" */))
const _0d1405a3 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/index" */))
const _54427b92 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/suggested_titles/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/suggested_titles/index" */))
const _7b1ecdab = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/assign_templates/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/assign_templates/index" */))
const _113ba774 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/new/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/new/index" */))
const _067fbf70 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/question_settings/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/question_settings/index" */))
const _d9d787a8 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/camera_capture/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/camera_capture/_question_id/index" */))
const _211fd56c = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/control_chart/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/control_chart/_question_id/index" */))
const _5929059a = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/heatmap/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/heatmap/_question_id/index" */))
const _c2bd2ad4 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/inspector_signature/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/inspector_signature/_question_id/index" */))
const _55e84f16 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/multi_select/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/multi_select/_question_id/index" */))
const _be825c8a = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/multi_value/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/multi_value/_question_id/index" */))
const _0303d91d = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/other_signature/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/other_signature/_question_id/index" */))
const _243fae02 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/part_verification/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/part_verification/_question_id/index" */))
const _7ac506ba = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/pass_fail/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/pass_fail/_question_id/index" */))
const _520ecba0 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/poke_yoke/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/poke_yoke/_question_id/index" */))
const _3265cd87 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/score_pass_fail/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/score_pass_fail/_question_id/index" */))
const _3e446e0a = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/severity/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/severity/_question_id/index" */))
const _54f48419 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/tolerance/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/tolerance/_question_id/index" */))
const _8f322d62 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/value_compare/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/value_compare/_question_id/index" */))
const _b24f0496 = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/questions/value/_question_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/questions/value/_question_id/index" */))
const _61e3a4bf = () => interopDefault(import('../pages/audit/questionnaires/_id/edit/index/expansions/_expansion_id/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/edit/index/expansions/_expansion_id/index" */))
const _60055194 = () => interopDefault(import('../pages/audit/questionnaires/_id/revisions/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/revisions/index" */))
const _71cb6082 = () => interopDefault(import('../pages/audit/questions/_id/failures_for_question/index.vue' /* webpackChunkName: "pages/audit/questions/_id/failures_for_question/index" */))
const _7a46095e = () => interopDefault(import('../pages/dashboard/panels/_id/my/index.vue' /* webpackChunkName: "pages/dashboard/panels/_id/my/index" */))
const _3290462b = () => interopDefault(import('../pages/reports/jobs/_id/ichart/index.vue' /* webpackChunkName: "pages/reports/jobs/_id/ichart/index" */))
const _d163e6be = () => interopDefault(import('../pages/training/exam_results/_id/reset_training/index.vue' /* webpackChunkName: "pages/training/exam_results/_id/reset_training/index" */))
const _7769244e = () => interopDefault(import('../pages/audit/questionnaire_groups/_id/questionnaires/new/index.vue' /* webpackChunkName: "pages/audit/questionnaire_groups/_id/questionnaires/new/index" */))
const _95a810f2 = () => interopDefault(import('../pages/audit/questionnaires/_id/revisions/new/index.vue' /* webpackChunkName: "pages/audit/questionnaires/_id/revisions/new/index" */))
const _3a2d7c08 = () => interopDefault(import('../pages/hrs/time_sheets/_time_sheet_id/activities/new/index.vue' /* webpackChunkName: "pages/hrs/time_sheets/_time_sheet_id/activities/new/index" */))
const _1aa6e9fa = () => interopDefault(import('../pages/hrs/time_sheets/_time_sheet_id/activities/_activity_id/index.vue' /* webpackChunkName: "pages/hrs/time_sheets/_time_sheet_id/activities/_activity_id/index" */))
const _45568fc2 = () => interopDefault(import('../pages/customers/jobs/_job_id/job_revisions/_job_revision_id/heatmap_search/index.vue' /* webpackChunkName: "pages/customers/jobs/_job_id/job_revisions/_job_revision_id/heatmap_search/index" */))
const _7c65d227 = () => interopDefault(import('../pages/customers/jobs/_job_id/job_revisions/_job_revision_id/downtime/logs/_log_id/index.vue' /* webpackChunkName: "pages/customers/jobs/_job_id/job_revisions/_job_revision_id/downtime/logs/_log_id/index" */))
const _7d64f149 = () => interopDefault(import('../pages/customers/jobs/_job_id/job_revisions/_job_revision_id/audit/questionnaires/_id/questionnaire_results/_questionnaire_result_id/index.vue' /* webpackChunkName: "pages/customers/jobs/_job_id/job_revisions/_job_revision_id/audit/questionnaires/_id/questionnaire_results/_questionnaire_result_id/index" */))
const _cfa8e694 = () => interopDefault(import('../pages/customers/jobs/_job_id/job_revisions/_job_revision_id/by_part_number/_part_number_name/index.vue' /* webpackChunkName: "pages/customers/jobs/_job_id/job_revisions/_job_revision_id/by_part_number/_part_number_name/index" */))
const _e823e002 = () => interopDefault(import('../pages/customers/jobs/_job_id/job_revisions/_job_revision_id/date_panel/_shift_id/index.vue' /* webpackChunkName: "pages/customers/jobs/_job_id/job_revisions/_job_revision_id/date_panel/_shift_id/index" */))
const _69277174 = () => interopDefault(import('../pages/customers/jobs/_job_id/job_revisions/_job_revision_id/bins/_bin_id/defects/_defect_id/edit/index.vue' /* webpackChunkName: "pages/customers/jobs/_job_id/job_revisions/_job_revision_id/bins/_bin_id/defects/_defect_id/edit/index" */))
const _6698d539 = () => interopDefault(import('../pages/changes/show/_model_name/_model_id/index.vue' /* webpackChunkName: "pages/changes/show/_model_name/_model_id/index" */))
const _bf0314fa = () => interopDefault(import('../pages/alerts/_alert_id/index.vue' /* webpackChunkName: "pages/alerts/_alert_id/index" */))
const _6e86d5ca = () => interopDefault(import('../pages/alerts/_alert_id/index/alert_results/index.vue' /* webpackChunkName: "pages/alerts/_alert_id/index/alert_results/index" */))
const _b41e838e = () => interopDefault(import('../pages/alerts/_alert_id/index/details/index.vue' /* webpackChunkName: "pages/alerts/_alert_id/index/details/index" */))
const _67c91ff0 = () => interopDefault(import('../pages/alerts/_alert_id/index/alert_results/_user_id.vue' /* webpackChunkName: "pages/alerts/_alert_id/index/alert_results/_user_id" */))
const _6a9f6a4b = () => interopDefault(import('../pages/custom_embeds/_id/index.vue' /* webpackChunkName: "pages/custom_embeds/_id/index" */))
const _6fe5a1a1 = () => interopDefault(import('../pages/customer_libraries/_id/index.vue' /* webpackChunkName: "pages/customer_libraries/_id/index" */))
const _05063f6e = () => interopDefault(import('../pages/data_logs/_device_id/index.vue' /* webpackChunkName: "pages/data_logs/_device_id/index" */))
const _7cc0f7f6 = () => interopDefault(import('../pages/recipient_libraries/_id/index.vue' /* webpackChunkName: "pages/recipient_libraries/_id/index" */))
const _33a8a8d1 = () => interopDefault(import('../pages/recover_password/_key/index.vue' /* webpackChunkName: "pages/recover_password/_key/index" */))
const _5eaba9bb = () => interopDefault(import('../pages/saved_report/_key/index.vue' /* webpackChunkName: "pages/saved_report/_key/index" */))
const _e229efea = () => interopDefault(import('../pages/users/_id/index.vue' /* webpackChunkName: "pages/users/_id/index" */))
const _3192a8a5 = () => interopDefault(import('../pages/cap/_zone_id/edit/index.vue' /* webpackChunkName: "pages/cap/_zone_id/edit/index" */))
const _539a0ab7 = () => interopDefault(import('../pages/customers/_id/edit/index.vue' /* webpackChunkName: "pages/customers/_id/edit/index" */))
const _25f51a9e = () => interopDefault(import('../pages/departments/_id/assign_teams_to_department/index.vue' /* webpackChunkName: "pages/departments/_id/assign_teams_to_department/index" */))
const _1caeafda = () => interopDefault(import('../pages/devices/_device_id/edit/index.vue' /* webpackChunkName: "pages/devices/_device_id/edit/index" */))
const _77beea9a = () => interopDefault(import('../pages/devices/_device_id/latest_shift/index.vue' /* webpackChunkName: "pages/devices/_device_id/latest_shift/index" */))
const _d7be073c = () => interopDefault(import('../pages/devices/_device_id/test/index.vue' /* webpackChunkName: "pages/devices/_device_id/test/index" */))
const _7c25090a = () => interopDefault(import('../pages/jobs/_job_id/alerts/index.vue' /* webpackChunkName: "pages/jobs/_job_id/alerts/index" */))
const _7011915b = () => interopDefault(import('../pages/jobs/_job_id/control_charts/index.vue' /* webpackChunkName: "pages/jobs/_job_id/control_charts/index" */))
const _0b7a59b8 = () => interopDefault(import('../pages/jobs/_job_id/cost_of_quality_list/index.vue' /* webpackChunkName: "pages/jobs/_job_id/cost_of_quality_list/index" */))
const _281538aa = () => interopDefault(import('../pages/jobs/_job_id/documents/index.vue' /* webpackChunkName: "pages/jobs/_job_id/documents/index" */))
const _8e9e3d24 = () => interopDefault(import('../pages/jobs/_job_id/edit/index.vue' /* webpackChunkName: "pages/jobs/_job_id/edit/index" */))
const _12bc0046 = () => interopDefault(import('../pages/jobs/_job_id/experience_table/index.vue' /* webpackChunkName: "pages/jobs/_job_id/experience_table/index" */))
const _40433ee8 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/index" */))
const _4cf53e1e = () => interopDefault(import('../pages/jobs/_job_id/recipients/index.vue' /* webpackChunkName: "pages/jobs/_job_id/recipients/index" */))
const _cd525f58 = () => interopDefault(import('../pages/jobs/_job_id/show_work_instruction/index.vue' /* webpackChunkName: "pages/jobs/_job_id/show_work_instruction/index" */))
const _053e8d5e = () => interopDefault(import('../pages/jobs/_job_id/stats/index.vue' /* webpackChunkName: "pages/jobs/_job_id/stats/index" */))
const _6f0c3c34 = () => interopDefault(import('../pages/jobs/_job_id/suspect_code_models/index.vue' /* webpackChunkName: "pages/jobs/_job_id/suspect_code_models/index" */))
const _b3e87b02 = () => interopDefault(import('../pages/restrictions/_id/edit/index.vue' /* webpackChunkName: "pages/restrictions/_id/edit/index" */))
const _592a7444 = () => interopDefault(import('../pages/scheduled_questionnaires/_id/edit/index.vue' /* webpackChunkName: "pages/scheduled_questionnaires/_id/edit/index" */))
const _c0a2933c = () => interopDefault(import('../pages/suspect_code_models/_model_id/edit/index.vue' /* webpackChunkName: "pages/suspect_code_models/_model_id/edit/index" */))
const _d80970b8 = () => interopDefault(import('../pages/users/_id/edit/index.vue' /* webpackChunkName: "pages/users/_id/edit/index" */))
const _6e2bc505 = () => interopDefault(import('../pages/zones/_id/edit/index.vue' /* webpackChunkName: "pages/zones/_id/edit/index" */))
const _5ae4036d = () => interopDefault(import('../pages/zones/_zone_id/queue_logs/index.vue' /* webpackChunkName: "pages/zones/_zone_id/queue_logs/index" */))
const _3bf2b639 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/new/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/new/index" */))
const _17c4c0fa = () => interopDefault(import('../pages/job_revisions/_job_revision_id/permutation/audit/questionnaire_sets/index.vue' /* webpackChunkName: "pages/job_revisions/_job_revision_id/permutation/audit/questionnaire_sets/index" */))
const _6938bc07 = () => interopDefault(import('../pages/jobs/_job_id/edit/barcode/_barcode_verification_id/index.vue' /* webpackChunkName: "pages/jobs/_job_id/edit/barcode/_barcode_verification_id/index" */))
const _4e343e77 = () => interopDefault(import('../pages/questionnaires/_questionnaire_id/audit/questionnaire_results/_id/index.vue' /* webpackChunkName: "pages/questionnaires/_questionnaire_id/audit/questionnaire_results/_id/index" */))
const _9bbd5d2e = () => interopDefault(import('../pages/jobs/_job_id/edit/barcode/_mask_type/work_item_field_masks/index.vue' /* webpackChunkName: "pages/jobs/_job_id/edit/barcode/_mask_type/work_item_field_masks/index" */))
const _08c1ba4b = () => interopDefault(import('../pages/jobs/_job_id/edit/barcode/_mask_type/work_item_field_masks/_mask_id/index.vue' /* webpackChunkName: "pages/jobs/_job_id/edit/barcode/_mask_type/work_item_field_masks/_mask_id/index" */))
const _5fcdfa74 = () => interopDefault(import('../pages/jobs/_job_id/edit/_constraint_type/index.vue' /* webpackChunkName: "pages/jobs/_job_id/edit/_constraint_type/index" */))
const _2ec5651b = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/index" */))
const _7a7dcbdc = () => interopDefault(import('../pages/departments/_id/zones/_zone_id/assign_zone_teams/index.vue' /* webpackChunkName: "pages/departments/_id/zones/_zone_id/assign_zone_teams/index" */))
const _4351d1ad = () => interopDefault(import('../pages/jobs/_job_id/alerts/_alert_id/alert_results/index.vue' /* webpackChunkName: "pages/jobs/_job_id/alerts/_alert_id/alert_results/index" */))
const _fa98d868 = () => interopDefault(import('../pages/jobs/_job_id/experience_table/_job_revision_id/view_signatures/index.vue' /* webpackChunkName: "pages/jobs/_job_id/experience_table/_job_revision_id/view_signatures/index" */))
const _2133a502 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/audit_expansions/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/audit_expansions/index" */))
const _41302678 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/defect_code_models/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/defect_code_models/index" */))
const _3bd3198e = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/downtime/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/downtime/index" */))
const _cb3ed6d8 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/edit/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/edit/index" */))
const _2ebc861f = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/ichart/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/ichart/index" */))
const _060eeb90 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/random_questionnaires/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/random_questionnaires/index" */))
const _1a019733 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/reference_pictures/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/reference_pictures/index" */))
const _76b8738a = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/shifts/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/shifts/index" */))
const _51a76aeb = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/stats/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/stats/index" */))
const _2118a64a = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/training_results/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/training_results/index" */))
const _12bc2d02 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/verification_work_items/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/verification_work_items/index" */))
const _7324ef80 = () => interopDefault(import('../pages/jobs/_job_id/recipients/_recipient_id/edit/index.vue' /* webpackChunkName: "pages/jobs/_job_id/recipients/_recipient_id/edit/index" */))
const _e3f7f364 = () => interopDefault(import('../pages/jobs/_job_id/experience_table/_job_revision_id/view_signatures/fieldDef.js' /* webpackChunkName: "pages/jobs/_job_id/experience_table/_job_revision_id/view_signatures/fieldDef" */))
const _0f5f4824 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/audit/questionnaires/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/audit/questionnaires/index" */))
const _2e002b4a = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/checklist/control_chart_instructions/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/checklist/control_chart_instructions/index" */))
const _1c59c9d2 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/failures/view/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/failures/view/index" */))
const _1d5b3ffc = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/heatmaps/search/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/heatmaps/search/index" */))
const _6cc22ae8 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/verification_work_items/import/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/verification_work_items/import/index" */))
const _ce272cdc = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/verification_work_items/stats/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/verification_work_items/stats/index" */))
const _344c67f4 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/downtime/logs/_id/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/downtime/logs/_id/index" */))
const _7e837c24 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/audit/questionnaires/_id/questionnaire_results/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/audit/questionnaires/_id/questionnaire_results/index" */))
const _0805347a = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/audit/questionnaires/_id/questionnaire_results/_questionnaire_result_id/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/audit/questionnaires/_id/questionnaire_results/_questionnaire_result_id/index" */))
const _84dc7576 = () => interopDefault(import('../pages/jobs/_job_id/alerts/_alert_id/alert_results/_user_id.vue' /* webpackChunkName: "pages/jobs/_job_id/alerts/_alert_id/alert_results/_user_id" */))
const _666c92f9 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/bins/_bin_id/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/bins/_bin_id/index" */))
const _4078657c = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/by_part_number/_part_number_name/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/by_part_number/_part_number_name/index" */))
const _af553c76 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/date_panel/_shift_id/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/date_panel/_shift_id/index" */))
const _5a896346 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/bins/_bin_id/show_barcode_verification_results/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/bins/_bin_id/show_barcode_verification_results/index" */))
const _8f0153fc = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/verification_work_items/_id/edit/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/verification_work_items/_id/edit/index" */))
const _c3803ec6 = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/bins/_bin_id/defects/new/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/bins/_bin_id/defects/new/index" */))
const _5c734d0c = () => interopDefault(import('../pages/jobs/_job_id/job_revisions/_job_revision_id/bins/_bin_id/defects/_defect_id/edit/index.vue' /* webpackChunkName: "pages/jobs/_job_id/job_revisions/_job_revision_id/bins/_bin_id/defects/_defect_id/edit/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/activity_logs",
    component: _8cfb4392,
    name: "activity_logs"
  }, {
    path: "/alerts",
    component: _02d7c695,
    name: "alerts"
  }, {
    path: "/audit_identifiers",
    component: _303ac89e,
    name: "audit_identifiers"
  }, {
    path: "/audit_types",
    component: _037b4fa6,
    name: "audit_types"
  }, {
    path: "/change_locale",
    component: _1125d2be,
    name: "change_locale"
  }, {
    path: "/custom_embeds",
    component: _e1d60140,
    name: "custom_embeds"
  }, {
    path: "/custom_tags",
    component: _b2827a82,
    name: "custom_tags"
  }, {
    path: "/customer_libraries",
    component: _059851b6,
    name: "customer_libraries"
  }, {
    path: "/departments",
    component: _f5e06d0e,
    name: "departments"
  }, {
    path: "/design",
    component: _44d33e08,
    name: "design"
  }, {
    path: "/devices",
    component: _20a36b16,
    name: "devices"
  }, {
    path: "/home",
    component: _40a1eb9d,
    name: "home"
  }, {
    path: "/jobs",
    component: _5785ab58,
    name: "jobs"
  }, {
    path: "/languages",
    component: _f3bf761a,
    name: "languages"
  }, {
    path: "/left_early_reasons",
    component: _7fab0e19,
    name: "left_early_reasons"
  }, {
    path: "/lessee_selection",
    component: _35e23a44,
    name: "lessee_selection"
  }, {
    path: "/licence_logs",
    component: _b58675ca,
    name: "licence_logs"
  }, {
    path: "/login",
    component: _33114d7e,
    name: "login"
  }, {
    path: "/ndas",
    component: _146163e6,
    name: "ndas"
  }, {
    path: "/question_tags",
    component: _45385e6a,
    name: "question_tags"
  }, {
    path: "/ranks",
    component: _24eac61f,
    name: "ranks"
  }, {
    path: "/recipient_libraries",
    component: _2ede1a8b,
    name: "recipient_libraries"
  }, {
    path: "/redis",
    component: _4be060d3,
    name: "redis"
  }, {
    path: "/report_statuses",
    component: _ecb0c43a,
    name: "report_statuses"
  }, {
    path: "/scheduled_questionnaires",
    component: _2bb8c700,
    name: "scheduled_questionnaires"
  }, {
    path: "/severities",
    component: _4a294dd9,
    name: "severities"
  }, {
    path: "/shift_descriptions",
    component: _5e880bd2,
    name: "shift_descriptions"
  }, {
    path: "/sites",
    component: _12c677b8,
    name: "sites"
  }, {
    path: "/states",
    component: _dfca2f80,
    name: "states"
  }, {
    path: "/superuser_only",
    component: _147b9e03,
    name: "superuser_only"
  }, {
    path: "/suspect_code_models",
    component: _83301de8,
    name: "suspect_code_models"
  }, {
    path: "/tablet_roles",
    component: _694985bc,
    name: "tablet_roles"
  }, {
    path: "/tags",
    component: _7b962b52,
    name: "tags"
  }, {
    path: "/unauthorized",
    component: _2545e672,
    name: "unauthorized"
  }, {
    path: "/users",
    component: _315505c0,
    name: "users"
  }, {
    path: "/work_areas",
    component: _cc61cfd4,
    name: "work_areas"
  }, {
    path: "/zones",
    component: _1fbd3e9f,
    name: "zones"
  }, {
    path: "/alerts/new",
    component: _0c719f66,
    name: "alerts-new"
  }, {
    path: "/audit/questionnaire_groups",
    component: _16b901e2,
    name: "audit-questionnaire_groups"
  }, {
    path: "/audit/scheduled_questionnaire_notifications",
    component: _560a275e,
    name: "audit-scheduled_questionnaire_notifications"
  }, {
    path: "/auth/signed-in",
    component: _08a2146c,
    name: "auth-signed-in"
  }, {
    path: "/customers/new",
    component: _7d651504,
    name: "customers-new"
  }, {
    path: "/dashboard/devices",
    component: _e1a7990c,
    name: "dashboard-devices"
  }, {
    path: "/dashboard/panels",
    component: _c247a170,
    name: "dashboard-panels"
  }, {
    path: "/defects/view_by_suspect_code",
    component: _038ee264,
    name: "defects-view_by_suspect_code"
  }, {
    path: "/departments/roles",
    component: _a5ae6532,
    name: "departments-roles"
  }, {
    path: "/design/TemplateForms",
    component: _de92c8bc,
    name: "design-TemplateForms",
    children: [{
      path: "Basic",
      component: _343dc43e,
      name: "design-TemplateForms-index-Basic"
    }, {
      path: "Fieldsets",
      component: _7233d1fe,
      name: "design-TemplateForms-index-Fieldsets"
    }, {
      path: "SubSections",
      component: _72251a01,
      name: "design-TemplateForms-index-SubSections"
    }, {
      path: "TabsInSections",
      component: _702576ee,
      name: "design-TemplateForms-index-TabsInSections"
    }]
  }, {
    path: "/devices/show_licence",
    component: _c0484d82,
    name: "devices-show_licence"
  }, {
    path: "/devices/unassigned",
    component: _4b7d78d7,
    name: "devices-unassigned"
  }, {
    path: "/downtime/reasons",
    component: _c5782d66,
    name: "downtime-reasons"
  }, {
    path: "/events/users",
    component: _bf63c4e0,
    name: "events-users"
  }, {
    path: "/failures/view_with_answer",
    component: _9a74868a,
    name: "failures-view_with_answer"
  }, {
    path: "/jobs/index_for_customer",
    component: _4f12aa92,
    name: "jobs-index_for_customer"
  }, {
    path: "/jobs/new",
    component: _20f10ba5,
    name: "jobs-new"
  }, {
    path: "/login/auth",
    component: _51c54a4c,
    name: "login-auth"
  }, {
    path: "/login/forgot_password",
    component: _4e78512e,
    name: "login-forgot_password"
  }, {
    path: "/login/mobile_auth",
    component: _1aadc457,
    name: "login-mobile_auth"
  }, {
    path: "/reports/atlas",
    component: _6ef98e93,
    name: "reports-atlas"
  }, {
    path: "/reports/backsheets",
    component: _a086092e,
    name: "reports-backsheets"
  }, {
    path: "/reports/corrective_actions",
    component: _6bdcde7a,
    name: "reports-corrective_actions"
  }, {
    path: "/reports/heatmap_search",
    component: _3f75e1ae,
    name: "reports-heatmap_search"
  }, {
    path: "/reports/heatmaps",
    component: _06ae5715,
    name: "reports-heatmaps"
  }, {
    path: "/reports/ichart",
    component: _d1bb7a3a,
    name: "reports-ichart"
  }, {
    path: "/reports/questionnaire_results",
    component: _21ff76a2,
    name: "reports-questionnaire_results"
  }, {
    path: "/reports/questionnaire_stats",
    component: _0a6cdf6a,
    name: "reports-questionnaire_stats"
  }, {
    path: "/reports/reject_stats",
    component: _8aae49e6,
    name: "reports-reject_stats"
  }, {
    path: "/reports/reject_summary",
    component: _5578aed8,
    name: "reports-reject_summary"
  }, {
    path: "/reports/shift_by_date",
    component: _cd7da13e,
    name: "reports-shift_by_date"
  }, {
    path: "/reports/shifts",
    component: _2d0982ff,
    name: "reports-shifts"
  }, {
    path: "/reports/stats",
    component: _12f505a7,
    name: "reports-stats"
  }, {
    path: "/reports/suspect_stats",
    component: _08472f5f,
    name: "reports-suspect_stats"
  }, {
    path: "/reports/training_results",
    component: _601176c2,
    name: "reports-training_results",
    children: [{
      path: ":exam_result_id",
      component: _11bf200f,
      name: "reports-training_results-index-exam_result_id"
    }, {
      path: ":user_id/by_user",
      component: _6f62c817,
      name: "reports-training_results-index-user_id-by_user"
    }]
  }, {
    path: "/reports/work_items",
    component: _347a8920,
    name: "reports-work_items"
  }, {
    path: "/suspect_code_models/new",
    component: _532c9346,
    name: "suspect_code_models-new"
  }, {
    path: "/training/exams",
    component: _7ade4dbd,
    name: "training-exams"
  }, {
    path: "/users/choose_deactivation",
    component: _9f7aace0,
    name: "users-choose_deactivation"
  }, {
    path: "/users/new",
    component: _76cb1871,
    name: "users-new"
  }, {
    path: "/workflows/simples",
    component: _4c6136c4,
    name: "workflows-simples"
  }, {
    path: "/zones/new",
    component: _6b2ffb20,
    name: "zones-new"
  }, {
    path: "/audit/scheduled_questionnaire_notifications/new",
    component: _6af718a2,
    name: "audit-scheduled_questionnaire_notifications-new"
  }, {
    path: "/dashboard/panels/new",
    component: _6c4712ce,
    name: "dashboard-panels-new"
  }, {
    path: "/design/1-Quarks/Colours",
    component: _f7973212,
    name: "design-1-Quarks-Colours"
  }, {
    path: "/design/1-Quarks/Fonts",
    component: _cd577f58,
    name: "design-1-Quarks-Fonts"
  }, {
    path: "/design/1-Quarks/Icons",
    component: _bb86cb2c,
    name: "design-1-Quarks-Icons"
  }, {
    path: "/design/2-Atoms/Button",
    component: _39666c40,
    name: "design-2-Atoms-Button"
  }, {
    path: "/design/2-Atoms/Checkbox",
    component: _31d5bf1e,
    name: "design-2-Atoms-Checkbox"
  }, {
    path: "/design/2-Atoms/EdnFieldset",
    component: _00d9d1b9,
    name: "design-2-Atoms-EdnFieldset"
  }, {
    path: "/design/2-Atoms/EdnMultiselects",
    component: _61ed34af,
    name: "design-2-Atoms-EdnMultiselects"
  }, {
    path: "/design/2-Atoms/InfoBannerSwitch",
    component: _9b46f308,
    name: "design-2-Atoms-InfoBannerSwitch"
  }, {
    path: "/design/2-Atoms/JobStatusIndicator",
    component: _512aa36e,
    name: "design-2-Atoms-JobStatusIndicator"
  }, {
    path: "/design/2-Atoms/ListWithDelete",
    component: _2e94ab7d,
    name: "design-2-Atoms-ListWithDelete"
  }, {
    path: "/design/2-Atoms/Loader",
    component: _40c30b7e,
    name: "design-2-Atoms-Loader"
  }, {
    path: "/design/2-Atoms/Pagination",
    component: _cad22970,
    name: "design-2-Atoms-Pagination"
  }, {
    path: "/design/2-Atoms/SearchableCheckboxes",
    component: _5eb33801,
    name: "design-2-Atoms-SearchableCheckboxes"
  }, {
    path: "/design/2-Atoms/SearchHeader",
    component: _fb93f1fa,
    name: "design-2-Atoms-SearchHeader"
  }, {
    path: "/design/2-Atoms/SliderToggle",
    component: _329e4443,
    name: "design-2-Atoms-SliderToggle"
  }, {
    path: "/design/2-Atoms/Table",
    component: _563f0390,
    name: "design-2-Atoms-Table"
  }, {
    path: "/design/2-Atoms/TextArea",
    component: _5360e6f0,
    name: "design-2-Atoms-TextArea"
  }, {
    path: "/design/2-Atoms/TextInput",
    component: _61fff9df,
    name: "design-2-Atoms-TextInput"
  }, {
    path: "/design/2-Atoms/Toggle",
    component: _c9c305fc,
    name: "design-2-Atoms-Toggle"
  }, {
    path: "/design/2-Atoms/ViewBy",
    component: _42266b8a,
    name: "design-2-Atoms-ViewBy"
  }, {
    path: "/design/3-Molecules/AutoLogOutModal",
    component: _287395bc,
    name: "design-3-Molecules-AutoLogOutModal"
  }, {
    path: "/design/3-Molecules/BarcodeVerification",
    component: _1e20db29,
    name: "design-3-Molecules-BarcodeVerification"
  }, {
    path: "/design/3-Molecules/Comments",
    component: _fbc2f614,
    name: "design-3-Molecules-Comments"
  }, {
    path: "/design/3-Molecules/EditExam",
    component: _5c7f79cb,
    name: "design-3-Molecules-EditExam"
  }, {
    path: "/design/3-Molecules/ExamResult",
    component: _5234799e,
    name: "design-3-Molecules-ExamResult"
  }, {
    path: "/design/3-Molecules/ImageUploader",
    component: _f6f6ca52,
    name: "design-3-Molecules-ImageUploader"
  }, {
    path: "/design/3-Molecules/JobQuestionnaires",
    component: _d7a0e58a,
    name: "design-3-Molecules-JobQuestionnaires"
  }, {
    path: "/design/3-Molecules/List",
    component: _8fb090c0,
    name: "design-3-Molecules-List"
  }, {
    path: "/design/3-Molecules/Modals",
    component: _21368be8,
    name: "design-3-Molecules-Modals"
  }, {
    path: "/design/3-Molecules/MyDashboard",
    component: _78116394,
    name: "design-3-Molecules-MyDashboard"
  }, {
    path: "/design/3-Molecules/PartsPerHourChart",
    component: _0f0d13ab,
    name: "design-3-Molecules-PartsPerHourChart"
  }, {
    path: "/design/3-Molecules/PayableTimeSummary",
    component: _524ea48e,
    name: "design-3-Molecules-PayableTimeSummary"
  }, {
    path: "/design/3-Molecules/RadarChart",
    component: _7a8cca0c,
    name: "design-3-Molecules-RadarChart"
  }, {
    path: "/design/3-Molecules/Selects",
    component: _63094665,
    name: "design-3-Molecules-Selects"
  }, {
    path: "/design/3-Molecules/StatsGraphs",
    component: _2e8d2852,
    name: "design-3-Molecules-StatsGraphs"
  }, {
    path: "/design/3-Molecules/StatsTableTotals",
    component: _fc297600,
    name: "design-3-Molecules-StatsTableTotals"
  }, {
    path: "/design/3-Molecules/Tabs",
    component: _32eeca80,
    name: "design-3-Molecules-Tabs"
  }, {
    path: "/design/DontCopyThis/StickyHeaderTable",
    component: _d060331a,
    name: "design-DontCopyThis-StickyHeaderTable"
  }, {
    path: "/design/Examples/Form",
    component: _747ff4f4,
    name: "design-Examples-Form"
  }, {
    path: "/design/TemplateForms/Validation",
    component: _1399270e,
    name: "design-TemplateForms-Validation"
  }, {
    path: "/hrs/reports/payable_hours_summary",
    component: _4f24779b,
    name: "hrs-reports-payable_hours_summary"
  }, {
    path: "/hrs/reports/roll_call",
    component: _fc57817c,
    name: "hrs-reports-roll_call"
  }, {
    path: "/hrs/reports/time_sheets",
    component: _3fb38c70,
    name: "hrs-reports-time_sheets"
  }, {
    path: "/hrs/reports/time_sheets_by_job",
    component: _6e0dd7c2,
    name: "hrs-reports-time_sheets_by_job"
  }, {
    path: "/importers/bundles/users",
    component: _5dd6d194,
    name: "importers-bundles-users"
  }, {
    path: "/library/assets/videos",
    component: _08891fb0,
    name: "library-assets-videos"
  }, {
    path: "/translations/roles/edit_all",
    component: _40528263,
    name: "translations-roles-edit_all"
  }, {
    path: "/audit/corrective_action/plans/list",
    component: _172e91fd,
    name: "audit-corrective_action-plans-list"
  }, {
    path: "/design/2-Atoms/Datetime/Datetime",
    component: _398b7ff1,
    name: "design-2-Atoms-Datetime-Datetime"
  }, {
    path: "/design/2-Atoms/Datetime/StartAndEndDate",
    component: _d6c80264,
    name: "design-2-Atoms-Datetime-StartAndEndDate"
  }, {
    path: "/design/2-Atoms/Datetime/StartDateComponent",
    component: _a9a92cba,
    name: "design-2-Atoms-Datetime-StartDateComponent"
  }, {
    path: "/design/3-Molecules/ActionCell/Default",
    component: _4e0d9968,
    name: "design-3-Molecules-ActionCell-Default"
  }, {
    path: "/design/3-Molecules/ActionCell/Editing",
    component: _73ffcf23,
    name: "design-3-Molecules-ActionCell-Editing"
  }, {
    path: "/design/3-Molecules/Audit/QuestionnaireResults",
    component: _557bf9a9,
    name: "design-3-Molecules-Audit-QuestionnaireResults"
  }, {
    path: "/design/3-Molecules/Gauges/AnswersBreakdown",
    component: _0f246ae2,
    name: "design-3-Molecules-Gauges-AnswersBreakdown"
  }, {
    path: "/design/3-Molecules/Gauges/AuditsPerformed",
    component: _7f32a315,
    name: "design-3-Molecules-Gauges-AuditsPerformed"
  }, {
    path: "/design/3-Molecules/Gauges/Compliance",
    component: _71919e3e,
    name: "design-3-Molecules-Gauges-Compliance"
  }, {
    path: "/design/3-Molecules/Gauges/CorrectiveActionResolution",
    component: _7464e573,
    name: "design-3-Molecules-Gauges-CorrectiveActionResolution"
  }, {
    path: "/design/3-Molecules/Gauges/EmbedLink",
    component: _be59ddc0,
    name: "design-3-Molecules-Gauges-EmbedLink"
  }, {
    path: "/design/3-Molecules/Gauges/ScheduledCompliance",
    component: _98cb1ad6,
    name: "design-3-Molecules-Gauges-ScheduledCompliance"
  }, {
    path: "/design/3-Molecules/Timesheets/ActivityDetails",
    component: _dfa823f2,
    name: "design-3-Molecules-Timesheets-ActivityDetails"
  }, {
    path: "/design/3-Molecules/Timesheets/NewActivity",
    component: _577286a3,
    name: "design-3-Molecules-Timesheets-NewActivity"
  }, {
    path: "/design/3-Molecules/Timesheets/NewShiftDescription",
    component: _0d60142e,
    name: "design-3-Molecules-Timesheets-NewShiftDescription"
  }, {
    path: "/design/3-Molecules/Timesheets/TimeByJobSummary",
    component: _172ce1ae,
    name: "design-3-Molecules-Timesheets-TimeByJobSummary"
  }, {
    path: "/design/3-Molecules/Timesheets/TimesheetsSearch",
    component: _486c09e5,
    name: "design-3-Molecules-Timesheets-TimesheetsSearch"
  }, {
    path: "/design/3-Molecules/Timesheets/ViewTimesheet",
    component: _d000ad3e,
    name: "design-3-Molecules-Timesheets-ViewTimesheet"
  }, {
    path: "/design/3-Molecules/Training/ExamResults",
    component: _02864204,
    name: "design-3-Molecules-Training-ExamResults"
  }, {
    path: "/design/3-Molecules/Training/ExamResultsSearchForm",
    component: _160338a0,
    name: "design-3-Molecules-Training-ExamResultsSearchForm"
  }, {
    path: "/design/TemplateForms/Search/FiltersInHeader",
    component: _53afbc26,
    name: "design-TemplateForms-Search-FiltersInHeader"
  }, {
    path: "/design/TemplateForms/Search/FiltersInHeaderWithPresets",
    component: _a88c0a10,
    name: "design-TemplateForms-Search-FiltersInHeaderWithPresets"
  }, {
    path: "/design/TemplateForms/Search/InASection",
    component: _351f3eba,
    name: "design-TemplateForms-Search-InASection",
    children: [{
      path: "Tab1",
      component: _e807e410,
      name: "design-TemplateForms-Search-InASection-index-Tab1"
    }, {
      path: "Tab2",
      component: _e7ebb50e,
      name: "design-TemplateForms-Search-InASection-index-Tab2"
    }]
  }, {
    path: "/importers/bundles/audit/questionnaire_groups",
    component: _40acbdee,
    name: "importers-bundles-audit-questionnaire_groups"
  }, {
    path: "/template/audit/corrective_action/champions",
    component: _64f10012,
    name: "template-audit-corrective_action-champions"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/QuestionnaireEdit",
    component: _a1473938,
    name: "design-3-Molecules-Audit-Questionnaires-QuestionnaireEdit"
  }, {
    path: "/design/3-Molecules/Gauges/AuditScore/BarChart",
    component: _54916bb0,
    name: "design-3-Molecules-Gauges-AuditScore-BarChart"
  }, {
    path: "/design/3-Molecules/Gauges/AuditScore/RadarChart",
    component: _3d9c66dd,
    name: "design-3-Molecules-Gauges-AuditScore-RadarChart"
  }, {
    path: "/design/3-Molecules/Gauges/CorrectiveAction/BarChart",
    component: _36bbcefa,
    name: "design-3-Molecules-Gauges-CorrectiveAction-BarChart"
  }, {
    path: "/design/3-Molecules/Gauges/CorrectiveAction/List",
    component: _69b3f816,
    name: "design-3-Molecules-Gauges-CorrectiveAction-List"
  }, {
    path: "/design/3-Molecules/Gauges/CorrectiveAction/PieChart",
    component: _e07809ac,
    name: "design-3-Molecules-Gauges-CorrectiveAction-PieChart"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/Answers",
    component: _eeb96adc,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-Answers"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/CameraCapture",
    component: _8c9bc684,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-CameraCapture"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/ControlChart",
    component: _0b259098,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-ControlChart"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/Heatmap",
    component: _2c3ddfee,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-Heatmap"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/InspectorSignatureAnswer",
    component: _7031035c,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-InspectorSignatureAnswer"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/Multiselect",
    component: _14370312,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-Multiselect"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/OtherSignature",
    component: _44fa587b,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-OtherSignature"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/PartVerification",
    component: _1bc9b8e1,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-PartVerification"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/PassFail",
    component: _0dabdefc,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-PassFail"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/PokeYoke",
    component: _06124a48,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-PokeYoke"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/ScorePassFail",
    component: _d559f844,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-ScorePassFail"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/Severity",
    component: _8b5bc4a0,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-Severity"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/Tolerance",
    component: _5b6308ea,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-Tolerance"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/Value",
    component: _d37ffa64,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-Value"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Answers/ValueCompare",
    component: _6c00c3e7,
    name: "design-3-Molecules-Audit-Questionnaires-Answers-ValueCompare"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/CameraCapture",
    component: _5147bbd6,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-CameraCapture"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/ControlChart",
    component: _289b559c,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-ControlChart"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/Heatmap",
    component: _64fc3dbe,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-Heatmap"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/InspectorSignature",
    component: _6556d65c,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-InspectorSignature"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/Multiselect",
    component: _ab4cefac,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-Multiselect"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/OtherSignature",
    component: _bfcec73a,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-OtherSignature"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/PartVerification",
    component: _2866a2c9,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-PartVerification"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/PassFail",
    component: _ecb93b2c,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-PassFail"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/ScorePassFail",
    component: _2ce8a2f6,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-ScorePassFail"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/Severity",
    component: _4acb6f98,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-Severity"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/Tolerance",
    component: _4bd817fc,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-Tolerance"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/Value",
    component: _059239e6,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-Value"
  }, {
    path: "/design/3-Molecules/Audit/Questionnaires/Questions/ValueCompare",
    component: _cba23c62,
    name: "design-3-Molecules-Audit-Questionnaires-Questions-ValueCompare"
  }, {
    path: "/",
    component: _6960d3b2,
    name: "index"
  }, {
    path: "/template/audit/corrective_action/champions/:id",
    component: _3421c762,
    name: "template-audit-corrective_action-champions-id"
  }, {
    path: "/importers/bundles/audit/questionnaire_groups/:id/edit",
    component: _8835e2d4,
    name: "importers-bundles-audit-questionnaire_groups-id-edit"
  }, {
    path: "/dashboard/devices/questionnaire_result/:device_identifier",
    component: _766f7f98,
    name: "dashboard-devices-questionnaire_result-device_identifier"
  }, {
    path: "/audit/answers/failures/:id?/edit",
    component: _50d4622f,
    name: "audit-answers-failures-id-edit"
  }, {
    path: "/dashboard/devices/jobs/:job?/embed",
    component: _06145ecc,
    name: "dashboard-devices-jobs-job-embed"
  }, {
    path: "/dashboard/devices/jobs/:job?/ichart",
    component: _5e2060d8,
    name: "dashboard-devices-jobs-job-ichart"
  }, {
    path: "/dashboard/devices/jobs/:job?/instruction_search",
    component: _53c3fd88,
    name: "dashboard-devices-jobs-job-instruction_search"
  }, {
    path: "/dashboard/devices/jobs/:job?/questionnaire_results",
    component: _25fd100d,
    name: "dashboard-devices-jobs-job-questionnaire_results"
  }, {
    path: "/dashboard/devices/jobs/:job?/questionnaires",
    component: _68fa4933,
    name: "dashboard-devices-jobs-job-questionnaires"
  }, {
    path: "/dashboard/devices/jobs/:job?/request_assistance",
    component: _123112eb,
    name: "dashboard-devices-jobs-job-request_assistance"
  }, {
    path: "/dashboard/devices/jobs/:job?/stats",
    component: _5b70d512,
    name: "dashboard-devices-jobs-job-stats"
  }, {
    path: "/dashboard/devices/jobs/:job?/verification_stats",
    component: _38a4ec84,
    name: "dashboard-devices-jobs-job-verification_stats"
  }, {
    path: "/dashboard/devices/jobs/:job?/verification_work_items",
    component: _7db3fb69,
    name: "dashboard-devices-jobs-job-verification_work_items"
  }, {
    path: "/dashboard/devices/questionnaire_results/:questionnaire_result_id?/questionnaire_result",
    component: _40897f7c,
    name: "dashboard-devices-questionnaire_results-questionnaire_result_id-questionnaire_result"
  }, {
    path: "/dashboard/devices/questions/:question_id?/failures_for_question",
    component: _43fe7376,
    name: "dashboard-devices-questions-question_id-failures_for_question"
  }, {
    path: "/importers/bundles/users/:id/edit",
    component: _ae0094a0,
    name: "importers-bundles-users-id-edit"
  }, {
    path: "/activity_logs/for_device/:device_id",
    component: _21d8aeb0,
    name: "activity_logs-for_device-device_id"
  }, {
    path: "/activity_logs/for_user/:user_id",
    component: _b992b474,
    name: "activity_logs-for_user-user_id"
  }, {
    path: "/audit/questionnaire_groups/:id",
    component: _b8cb4866,
    name: "audit-questionnaire_groups-id"
  }, {
    path: "/dashboard/panels/:id",
    component: _3c07339a,
    name: "dashboard-panels-id"
  }, {
    path: "/hrs/time_sheets/:time_sheet_id",
    component: _6176cc5b,
    name: "hrs-time_sheets-time_sheet_id"
  }, {
    path: "/saved_report/ichart/:key",
    component: _4a321816,
    name: "saved_report-ichart-key"
  }, {
    path: "/saved_report/view_all_shifts/:key",
    component: _58088bbe,
    name: "saved_report-view_all_shifts-key"
  }, {
    path: "/saved_report/view_defect_by_description/:key",
    component: _afaf53bc,
    name: "saved_report-view_defect_by_description-key"
  }, {
    path: "/scheduled_questionnaires/new/:zone_id",
    component: _cfcc57ba,
    name: "scheduled_questionnaires-new-zone_id"
  }, {
    path: "/training/exams/:exam_id",
    component: _0fd913b8,
    name: "training-exams-exam_id"
  }, {
    path: "/audit/questionnaire_groups/:id/questionnaires",
    component: _a82e72f0,
    name: "audit-questionnaire_groups-id-questionnaires"
  }, {
    path: "/audit/questionnaires/:id?/edit",
    component: _57bb04a2,
    children: [{
      path: "",
      component: _f433ecb6,
      name: "audit-questionnaires-id-edit-index"
    }, {
      path: "expansions",
      component: _a94dc0d8,
      name: "audit-questionnaires-id-edit-index-expansions"
    }, {
      path: "questions",
      component: _0d1405a3,
      name: "audit-questionnaires-id-edit-index-questions"
    }, {
      path: "suggested_titles",
      component: _54427b92,
      name: "audit-questionnaires-id-edit-index-suggested_titles"
    }, {
      path: "questions/assign_templates",
      component: _7b1ecdab,
      name: "audit-questionnaires-id-edit-index-questions-assign_templates"
    }, {
      path: "questions/new",
      component: _113ba774,
      name: "audit-questionnaires-id-edit-index-questions-new"
    }, {
      path: "questions/question_settings",
      component: _067fbf70,
      name: "audit-questionnaires-id-edit-index-questions-question_settings"
    }, {
      path: "questions/camera_capture/:question_id",
      component: _d9d787a8,
      name: "audit-questionnaires-id-edit-index-questions-camera_capture-question_id"
    }, {
      path: "questions/control_chart/:question_id",
      component: _211fd56c,
      name: "audit-questionnaires-id-edit-index-questions-control_chart-question_id"
    }, {
      path: "questions/heatmap/:question_id",
      component: _5929059a,
      name: "audit-questionnaires-id-edit-index-questions-heatmap-question_id"
    }, {
      path: "questions/inspector_signature/:question_id",
      component: _c2bd2ad4,
      name: "audit-questionnaires-id-edit-index-questions-inspector_signature-question_id"
    }, {
      path: "questions/multi_select/:question_id",
      component: _55e84f16,
      name: "audit-questionnaires-id-edit-index-questions-multi_select-question_id"
    }, {
      path: "questions/multi_value/:question_id",
      component: _be825c8a,
      name: "audit-questionnaires-id-edit-index-questions-multi_value-question_id"
    }, {
      path: "questions/other_signature/:question_id",
      component: _0303d91d,
      name: "audit-questionnaires-id-edit-index-questions-other_signature-question_id"
    }, {
      path: "questions/part_verification/:question_id",
      component: _243fae02,
      name: "audit-questionnaires-id-edit-index-questions-part_verification-question_id"
    }, {
      path: "questions/pass_fail/:question_id",
      component: _7ac506ba,
      name: "audit-questionnaires-id-edit-index-questions-pass_fail-question_id"
    }, {
      path: "questions/poke_yoke/:question_id",
      component: _520ecba0,
      name: "audit-questionnaires-id-edit-index-questions-poke_yoke-question_id"
    }, {
      path: "questions/score_pass_fail/:question_id",
      component: _3265cd87,
      name: "audit-questionnaires-id-edit-index-questions-score_pass_fail-question_id"
    }, {
      path: "questions/severity/:question_id",
      component: _3e446e0a,
      name: "audit-questionnaires-id-edit-index-questions-severity-question_id"
    }, {
      path: "questions/tolerance/:question_id",
      component: _54f48419,
      name: "audit-questionnaires-id-edit-index-questions-tolerance-question_id"
    }, {
      path: "questions/value_compare/:question_id",
      component: _8f322d62,
      name: "audit-questionnaires-id-edit-index-questions-value_compare-question_id"
    }, {
      path: "questions/value/:question_id",
      component: _b24f0496,
      name: "audit-questionnaires-id-edit-index-questions-value-question_id"
    }, {
      path: "expansions/:expansion_id",
      component: _61e3a4bf,
      name: "audit-questionnaires-id-edit-index-expansions-expansion_id"
    }]
  }, {
    path: "/audit/questionnaires/:id?/revisions",
    component: _60055194,
    name: "audit-questionnaires-id-revisions"
  }, {
    path: "/audit/questions/:id?/failures_for_question",
    component: _71cb6082,
    name: "audit-questions-id-failures_for_question"
  }, {
    path: "/dashboard/panels/:id/my",
    component: _7a46095e,
    name: "dashboard-panels-id-my"
  }, {
    path: "/reports/jobs/:id?/ichart",
    component: _3290462b,
    name: "reports-jobs-id-ichart"
  }, {
    path: "/training/exam_results/:id?/reset_training",
    component: _d163e6be,
    name: "training-exam_results-id-reset_training"
  }, {
    path: "/audit/questionnaire_groups/:id/questionnaires/new",
    component: _7769244e,
    name: "audit-questionnaire_groups-id-questionnaires-new"
  }, {
    path: "/audit/questionnaires/:id?/revisions/new",
    component: _95a810f2,
    name: "audit-questionnaires-id-revisions-new"
  }, {
    path: "/hrs/time_sheets/:time_sheet_id?/activities/new",
    component: _3a2d7c08,
    name: "hrs-time_sheets-time_sheet_id-activities-new"
  }, {
    path: "/hrs/time_sheets/:time_sheet_id?/activities/:activity_id",
    component: _1aa6e9fa,
    name: "hrs-time_sheets-time_sheet_id-activities-activity_id"
  }, {
    path: "/customers/jobs/:job_id?/job_revisions/:job_revision_id?/heatmap_search",
    component: _45568fc2,
    name: "customers-jobs-job_id-job_revisions-job_revision_id-heatmap_search"
  }, {
    path: "/customers/jobs/:job_id?/job_revisions/:job_revision_id?/downtime/logs/:log_id",
    component: _7c65d227,
    name: "customers-jobs-job_id-job_revisions-job_revision_id-downtime-logs-log_id"
  }, {
    path: "/customers/jobs/:job_id?/job_revisions/:job_revision_id?/audit/questionnaires/:id?/questionnaire_results/:questionnaire_result_id",
    component: _7d64f149,
    name: "customers-jobs-job_id-job_revisions-job_revision_id-audit-questionnaires-id-questionnaire_results-questionnaire_result_id"
  }, {
    path: "/customers/jobs/:job_id?/job_revisions/:job_revision_id?/by_part_number/:part_number_name",
    component: _cfa8e694,
    name: "customers-jobs-job_id-job_revisions-job_revision_id-by_part_number-part_number_name"
  }, {
    path: "/customers/jobs/:job_id?/job_revisions/:job_revision_id?/date_panel/:shift_id",
    component: _e823e002,
    name: "customers-jobs-job_id-job_revisions-job_revision_id-date_panel-shift_id"
  }, {
    path: "/customers/jobs/:job_id?/job_revisions/:job_revision_id?/bins/:bin_id?/defects/:defect_id?/edit",
    component: _69277174,
    name: "customers-jobs-job_id-job_revisions-job_revision_id-bins-bin_id-defects-defect_id-edit"
  }, {
    path: "/changes/show/:model_name?/:model_id",
    component: _6698d539,
    name: "changes-show-model_name-model_id"
  }, {
    path: "/alerts/:alert_id",
    component: _bf0314fa,
    name: "alerts-alert_id",
    children: [{
      path: "alert_results",
      component: _6e86d5ca,
      name: "alerts-alert_id-index-alert_results"
    }, {
      path: "details",
      component: _b41e838e,
      name: "alerts-alert_id-index-details"
    }, {
      path: "alert_results/:user_id?",
      component: _67c91ff0,
      name: "alerts-alert_id-index-alert_results-user_id"
    }]
  }, {
    path: "/custom_embeds/:id",
    component: _6a9f6a4b,
    name: "custom_embeds-id"
  }, {
    path: "/customer_libraries/:id",
    component: _6fe5a1a1,
    name: "customer_libraries-id"
  }, {
    path: "/data_logs/:device_id",
    component: _05063f6e,
    name: "data_logs-device_id"
  }, {
    path: "/recipient_libraries/:id",
    component: _7cc0f7f6,
    name: "recipient_libraries-id"
  }, {
    path: "/recover_password/:key",
    component: _33a8a8d1,
    name: "recover_password-key"
  }, {
    path: "/saved_report/:key",
    component: _5eaba9bb,
    name: "saved_report-key"
  }, {
    path: "/users/:id",
    component: _e229efea,
    name: "users-id"
  }, {
    path: "/cap/:zone_id?/edit",
    component: _3192a8a5,
    name: "cap-zone_id-edit"
  }, {
    path: "/customers/:id?/edit",
    component: _539a0ab7,
    name: "customers-id-edit"
  }, {
    path: "/departments/:id/assign_teams_to_department",
    component: _25f51a9e,
    name: "departments-id-assign_teams_to_department"
  }, {
    path: "/devices/:device_id/edit",
    component: _1caeafda,
    name: "devices-device_id-edit"
  }, {
    path: "/devices/:device_id/latest_shift",
    component: _77beea9a,
    name: "devices-device_id-latest_shift"
  }, {
    path: "/devices/:device_id/test",
    component: _d7be073c,
    name: "devices-device_id-test"
  }, {
    path: "/jobs/:job_id/alerts",
    component: _7c25090a,
    name: "jobs-job_id-alerts"
  }, {
    path: "/jobs/:job_id/control_charts",
    component: _7011915b,
    name: "jobs-job_id-control_charts"
  }, {
    path: "/jobs/:job_id/cost_of_quality_list",
    component: _0b7a59b8,
    name: "jobs-job_id-cost_of_quality_list"
  }, {
    path: "/jobs/:job_id/documents",
    component: _281538aa,
    name: "jobs-job_id-documents"
  }, {
    path: "/jobs/:job_id/edit",
    component: _8e9e3d24,
    name: "jobs-job_id-edit"
  }, {
    path: "/jobs/:job_id/experience_table",
    component: _12bc0046,
    name: "jobs-job_id-experience_table"
  }, {
    path: "/jobs/:job_id/job_revisions",
    component: _40433ee8,
    name: "jobs-job_id-job_revisions"
  }, {
    path: "/jobs/:job_id/recipients",
    component: _4cf53e1e,
    name: "jobs-job_id-recipients"
  }, {
    path: "/jobs/:job_id/show_work_instruction",
    component: _cd525f58,
    name: "jobs-job_id-show_work_instruction"
  }, {
    path: "/jobs/:job_id/stats",
    component: _053e8d5e,
    name: "jobs-job_id-stats"
  }, {
    path: "/jobs/:job_id/suspect_code_models",
    component: _6f0c3c34,
    name: "jobs-job_id-suspect_code_models"
  }, {
    path: "/restrictions/:id?/edit",
    component: _b3e87b02,
    name: "restrictions-id-edit"
  }, {
    path: "/scheduled_questionnaires/:id/edit",
    component: _592a7444,
    name: "scheduled_questionnaires-id-edit"
  }, {
    path: "/suspect_code_models/:model_id/edit",
    component: _c0a2933c,
    name: "suspect_code_models-model_id-edit"
  }, {
    path: "/users/:id/edit",
    component: _d80970b8,
    name: "users-id-edit"
  }, {
    path: "/zones/:id/edit",
    component: _6e2bc505,
    name: "zones-id-edit"
  }, {
    path: "/zones/:zone_id/queue_logs",
    component: _5ae4036d,
    name: "zones-zone_id-queue_logs"
  }, {
    path: "/jobs/:job_id/job_revisions/new",
    component: _3bf2b639,
    name: "jobs-job_id-job_revisions-new"
  }, {
    path: "/job_revisions/:job_revision_id?/permutation/audit/questionnaire_sets",
    component: _17c4c0fa,
    name: "job_revisions-job_revision_id-permutation-audit-questionnaire_sets"
  }, {
    path: "/jobs/:job_id/edit/barcode/:barcode_verification_id",
    component: _6938bc07,
    name: "jobs-job_id-edit-barcode-barcode_verification_id"
  }, {
    path: "/questionnaires/:questionnaire_id?/audit/questionnaire_results/:id",
    component: _4e343e77,
    name: "questionnaires-questionnaire_id-audit-questionnaire_results-id"
  }, {
    path: "/jobs/:job_id/edit/barcode/:mask_type?/work_item_field_masks",
    component: _9bbd5d2e,
    name: "jobs-job_id-edit-barcode-mask_type-work_item_field_masks"
  }, {
    path: "/jobs/:job_id/edit/barcode/:mask_type?/work_item_field_masks/:mask_id",
    component: _08c1ba4b,
    name: "jobs-job_id-edit-barcode-mask_type-work_item_field_masks-mask_id"
  }, {
    path: "/jobs/:job_id/edit/:constraint_type",
    component: _5fcdfa74,
    name: "jobs-job_id-edit-constraint_type"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id",
    component: _2ec5651b,
    name: "jobs-job_id-job_revisions-job_revision_id"
  }, {
    path: "/departments/:id/zones/:zone_id?/assign_zone_teams",
    component: _7a7dcbdc,
    name: "departments-id-zones-zone_id-assign_zone_teams"
  }, {
    path: "/jobs/:job_id/alerts/:alert_id/alert_results",
    component: _4351d1ad,
    name: "jobs-job_id-alerts-alert_id-alert_results"
  }, {
    path: "/jobs/:job_id/experience_table/:job_revision_id/view_signatures",
    component: _fa98d868,
    name: "jobs-job_id-experience_table-job_revision_id-view_signatures"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/audit_expansions",
    component: _2133a502,
    name: "jobs-job_id-job_revisions-job_revision_id-audit_expansions"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/defect_code_models",
    component: _41302678,
    name: "jobs-job_id-job_revisions-job_revision_id-defect_code_models"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/downtime",
    component: _3bd3198e,
    name: "jobs-job_id-job_revisions-job_revision_id-downtime"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/edit",
    component: _cb3ed6d8,
    name: "jobs-job_id-job_revisions-job_revision_id-edit"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/ichart",
    component: _2ebc861f,
    name: "jobs-job_id-job_revisions-job_revision_id-ichart"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/random_questionnaires",
    component: _060eeb90,
    name: "jobs-job_id-job_revisions-job_revision_id-random_questionnaires"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/reference_pictures",
    component: _1a019733,
    name: "jobs-job_id-job_revisions-job_revision_id-reference_pictures"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/shifts",
    component: _76b8738a,
    name: "jobs-job_id-job_revisions-job_revision_id-shifts"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/stats",
    component: _51a76aeb,
    name: "jobs-job_id-job_revisions-job_revision_id-stats"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/training_results",
    component: _2118a64a,
    name: "jobs-job_id-job_revisions-job_revision_id-training_results"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/verification_work_items",
    component: _12bc2d02,
    name: "jobs-job_id-job_revisions-job_revision_id-verification_work_items"
  }, {
    path: "/jobs/:job_id/recipients/:recipient_id/edit",
    component: _7324ef80,
    name: "jobs-job_id-recipients-recipient_id-edit"
  }, {
    path: "/jobs/:job_id/experience_table/:job_revision_id/view_signatures/fieldDef",
    component: _e3f7f364,
    name: "jobs-job_id-experience_table-job_revision_id-view_signatures-fieldDef"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/audit/questionnaires",
    component: _0f5f4824,
    name: "jobs-job_id-job_revisions-job_revision_id-audit-questionnaires"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/checklist/control_chart_instructions",
    component: _2e002b4a,
    name: "jobs-job_id-job_revisions-job_revision_id-checklist-control_chart_instructions"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/failures/view",
    component: _1c59c9d2,
    name: "jobs-job_id-job_revisions-job_revision_id-failures-view"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/heatmaps/search",
    component: _1d5b3ffc,
    name: "jobs-job_id-job_revisions-job_revision_id-heatmaps-search"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/verification_work_items/import",
    component: _6cc22ae8,
    name: "jobs-job_id-job_revisions-job_revision_id-verification_work_items-import"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/verification_work_items/stats",
    component: _ce272cdc,
    name: "jobs-job_id-job_revisions-job_revision_id-verification_work_items-stats"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/downtime/logs/:id",
    component: _344c67f4,
    name: "jobs-job_id-job_revisions-job_revision_id-downtime-logs-id"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/audit/questionnaires/:id/questionnaire_results",
    component: _7e837c24,
    name: "jobs-job_id-job_revisions-job_revision_id-audit-questionnaires-id-questionnaire_results"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/audit/questionnaires/:id/questionnaire_results/:questionnaire_result_id",
    component: _0805347a,
    name: "jobs-job_id-job_revisions-job_revision_id-audit-questionnaires-id-questionnaire_results-questionnaire_result_id"
  }, {
    path: "/jobs/:job_id/alerts/:alert_id/alert_results/:user_id",
    component: _84dc7576,
    name: "jobs-job_id-alerts-alert_id-alert_results-user_id"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/bins/:bin_id",
    component: _666c92f9,
    name: "jobs-job_id-job_revisions-job_revision_id-bins-bin_id"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/by_part_number/:part_number_name",
    component: _4078657c,
    name: "jobs-job_id-job_revisions-job_revision_id-by_part_number-part_number_name"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/date_panel/:shift_id",
    component: _af553c76,
    name: "jobs-job_id-job_revisions-job_revision_id-date_panel-shift_id"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/bins/:bin_id?/show_barcode_verification_results",
    component: _5a896346,
    name: "jobs-job_id-job_revisions-job_revision_id-bins-bin_id-show_barcode_verification_results"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/verification_work_items/:id/edit",
    component: _8f0153fc,
    name: "jobs-job_id-job_revisions-job_revision_id-verification_work_items-id-edit"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/bins/:bin_id?/defects/new",
    component: _c3803ec6,
    name: "jobs-job_id-job_revisions-job_revision_id-bins-bin_id-defects-new"
  }, {
    path: "/jobs/:job_id/job_revisions/:job_revision_id/bins/:bin_id?/defects/:defect_id?/edit",
    component: _5c734d0c,
    name: "jobs-job_id-job_revisions-job_revision_id-bins-bin_id-defects-defect_id-edit"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
